<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">Edit Enquiry</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>

<div class="modal-body">
  <form [formGroup]="editEnquiry" autocomplete="off">

    <div class="mb-3">
      <label class="form-label">Enquiry</label>
      <textarea class="form-control" 
                #enquiry
                formControlName="enquiry" 
                placeholder="Enquiry"
                maxlength="300"
                rows="4"></textarea>
      <div class="form-text text-end">{{enquiry.value?.length || 0}}/300</div>
    </div>

  </form>
</div>

<div class="modal-footer">
  <button type="button" 
          class="btn btn-success" 
          (click)="save()">
    Save
  </button>
</div>